import type { RouterConfig } from "@nuxt/schema";
import { useStore } from '@/stores/index'

export default <RouterConfig>{
	routes: (_routes) => [
		{
			name: "chirashi",
			path: "/chirashi",
			component: () => import("~/pages/chirashi/index.vue"),
			meta: {
				title: "チラシ",
			},
		},
		{
			name: "index",
			path: "/",
			component: () => import("~/pages/index.vue"),
			meta: {
				title: "index",
			},
		},
		{
			name: "faq",
			path: "/faq",
			component: () => import("~/pages/faq/index.vue"),
			meta: {
				title: "よくあるご質問",
			},
		},
		{
			name: "privacy-policy",
			path: "/privacy-policy",
			component: () => import("~/pages/privacy-policy/index.vue"),
			meta: {
				title: "プライバシーポリシー",
			},
		},
		{
			name: "chirashi-viewer",
			path: "/chirashi/viewer",
			component: () => import("~/pages/chirashi/viewer.vue"),
			meta: {
				title: "チラシビュワー",
			},
			beforeEnter: (to, from) => {
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
		{
			name: "theme",
			path: "/theme",
			component: () => import("~/pages/theme/index.vue"),
			meta: {
				title: "テーマ",
			},
			beforeEnter: (to, from) => {
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
		{
			name: "maker-theme",
			path: "/maker-theme",
			component: () => import("~/pages/maker-theme/index.vue"),
			meta: {
				title: "メーカーテーマ",
			},
			beforeEnter: (to, from) => {
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
		{
			name: "maker-theme-survey",
			path: "/maker-theme/survey",
			component: () => import("~/pages/maker-theme/survey/index.vue"),
			meta: {
				title: "アンケート",
			},
			beforeEnter: (to, from) => {
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
		{
			name: "mystore",
			path: "/my-store",
			component: () => import("~/pages/my-store/index.vue"),
			meta: {
				title: "マイ店舗検索",
			},
			beforeEnter: (to, from) => {
				const runtimeConfig = useRuntimeConfig()
				if (runtimeConfig.public.singleStore) {
					return false
				}
				return true
			}
		},
		{
			name: "mystore-search",
			path: "/my-store/search",
			component: () => import("~/pages/my-store/search/index.vue"),
			meta: {
				title: "マイ店舗検索",
			},
			beforeEnter: (to, from) => {
				const runtimeConfig = useRuntimeConfig()
				if (runtimeConfig.public.singleStore) {
					return false
				}
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
		{
			name: "mystore-type",
			path: "/my-store/search/:type",
			component: () => import("~/pages/my-store/search/[type].vue"),
			meta: {
				title: "マイ店舗検索",
			},
			beforeEnter: (to, from) => {
				const runtimeConfig = useRuntimeConfig()
				if (runtimeConfig.public.singleStore) {
					return false
				}
				return true
			}
		},
		{
			name: "content-survey",
			path: "/content/survey",
			component: () => import("~/pages/content/survey/index.vue"),
			meta: {
				title: "アンケート",
			},
			beforeEnter: (to, from) => {
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
		{
			name: "content",
			path: "/content/:id",
			component: () => import("~/pages/content/[id].vue"),
			meta: {
				title: "コンテンツ",
			},
			beforeEnter: (to, from) => {
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
		{
			name: "product",
			path: "/product",
			component: () => import("~/pages/product/index.vue"),
			meta: {
				title: "商品詳細",
			},
			beforeEnter: (to, from) => {
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
		{
			name: "iframe",
			path: "/chirashi/iframe",
			component: () => import("~/pages/chirashi/iframe.vue"),
			meta: {
				title: "iframe",
			},
		},
		{
			name: "preview-chirashi",
			path: "/preview/chirashi",
			component: () => import("~/pages/preview/chirashi/index.vue"),
			meta: {
				title: "チラシ",
			},
		},
		{
			name: "preview-viewer",
			path: "/preview/chirashi/viewer",
			component: () => import("~/pages/preview/chirashi/viewer.vue"),
			meta: {
				title: "チラシビュワー",
			},
			beforeEnter: (to, from) => {
				localStorage.setItem('prevRoute', from.fullPath)
				return true
			}
		},
	],
};
